jQuery(document).ready(function () {

  $("#modal_recruiter_service").on("click", "#confirmModalActivate, #confirmModalDeactivate", function (e) {
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
    var recruiterId = $(this).data('recruiter-id');
    var recruiterName = $(this).data('recruiter-name');
    var serviceName = $(this).data('service-name');
    var serviceTitle = $(this).data('service-title');
    var clientId = $(this).data('client-id');
    var clientName = $(this).data('client-name');
    var productId = parseInt($(this).data('product-id'));
    var productTitle = productId === 1 ? 'EFY' : 'BIE';
    var switchElement = $(this);
    var currentState = $(this).is(':checked');

    Swal.fire({
      title: '¡Atención!',
      text: '¿Está segura/o de ' + (currentState ? 'activar' : 'desactivar') + ' el acceso a ' + (productId ? productTitle + ' en ' : '') + serviceTitle + ' para ' + recruiterName + ' en ' + clientName + '?',
      icon: 'warning',
      allowEscapeKey: false,
      allowEnterKey: false,
      buttonsStyling: false,

      allowOutsideClick: false,
      confirmButtonText: (currentState ? 'Activar' : 'Desactivar'),
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-fj-purple",
        cancelButton: "btn btn-light"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        performServiceAction(serviceName, clientId, recruiterId, recruiterName, productId, AUTH_TOKEN, currentState, false, switchElement);
      } else {
        if (switchElement.length > 0) {
          switchElement.prop("checked", !currentState);
        }
      }
    });
  });

  function performServiceAction(serviceName, clientId, recruiterId, recruiterName, productsIds, AUTH_TOKEN, activate, is_access_request, switchElement = null) {
    Swal.fire({
      title: 'Realizando acción...',
      text: "Por favor espere mientras se procesa la acción",
      icon: 'info',
      allowEscapeKey: false,
      allowEnterKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });

    productsIds = Array.isArray(productsIds) ? productsIds : (productsIds ? [productsIds] : []);

    const SWAL_BASE_CONFIG = {
      buttonsStyling: false,
      confirmButtonText: "Aceptar",
      customClass: { confirmButton: "btn btn-fj-purple" }
    };
    
    const SWAL_CONFIGS = {
      warning: {
        ...SWAL_BASE_CONFIG,
        icon: "warning"
      },
      success: {
        ...SWAL_BASE_CONFIG,
        icon: "success",
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false
      },
      error: {
        ...SWAL_BASE_CONFIG,
        icon: "error"
      }
    };
    
    function updateSwitch(isActive) {
      if (switchElement && switchElement.length > 0) {
        if (isActive) {
          $('.switch-icon').removeClass('switch-light').addClass('switch-success');
          switchElement.data('is-active', true);
        } else {
          switchElement.prop("checked", false);
        }
      }
    }
    
    function handleAfterAlert() {
      if (is_access_request) {
        $.ajax({
          url: `/empresa/reclutadores/${recruiterId}/servicios`,
          type: 'GET',
          dataType: 'script'
        });
      }
    }
    
    $.ajax({
      type: 'POST',
      url: `/empresa/reclutadores/${recruiterId}/servicios/activate`,
      dataType: 'json',
      timeout: 15000,
      data: {
        client_id: clientId,
        service: serviceName,
        product_id: productsIds,
        activate,
        authenticity_token: AUTH_TOKEN,
        is_access_request
      },
      success: function(response) {
        const swalConfig = response.error === "active_access" 
          ? { ...SWAL_CONFIGS.warning, text: response.message }
          : { ...SWAL_CONFIGS.success,
              title: `¡Servicio ${activate ? 'Activado' : 'Desactivado'}!`,
              text: `El servicio se ${activate ? 'activó' : 'desactivó'} correctamente para ${recruiterName}.`
            };
        Swal.fire(swalConfig).then(handleAfterAlert);
        updateSwitch(true);
      },
      error: function(_, textStatus) {
        const baseMsg = `Hubo un problema al ${activate ? 'activar' : 'desactivar'} el servicio.`;
        const timeoutMsg = 'La operación excedió el tiempo de espera.';
        const retryMsg = 'Por favor vuelve a intentar en unos minutos.';
        
        Swal.fire({
          ...SWAL_CONFIGS.error,
          text: `${baseMsg}${textStatus === 'timeout' ? timeoutMsg : retryMsg}`
        }).then(handleAfterAlert);
        
        updateSwitch(false);
      }
    });
  }

  const $tokenElement = $("#psat");
  if ($tokenElement.length > 0) {
  
    const tokenData = $tokenElement.data("td");

    if (tokenData) {
      if (tokenData.err) {
        Swal.fire({
          title: 'Hubo un error!',
          text: tokenData.err,
          icon: 'error',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          confirmButtonText: "Ok",
        });
      } else {
      
        var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
        
        var recruiterId = tokenData.ri;
        var clientId = tokenData.ci;
        var service = tokenData.sr;
        var productsIds = tokenData.pis;
        var productsName = tokenData.pn;
        var recruiterName = tokenData.rn;
        var clientName = tokenData.cn;
        var productTitle = '';
        if (productsName.length >= 1) {
          productTitle = productsName.length > 1 ? productsName.join(" y ") : productsName[0];
        }

        Swal.fire({
          title: '¡Atención!',
          text: '¿Está segura/o de activar el acceso a ' + (productsIds.length > 0 ? productTitle + ' en ' : '') + service["title"] + ' para ' + recruiterName + ' en ' + clientName + '?',
          icon: 'warning',
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,

          allowOutsideClick: false,
          confirmButtonText: 'Activar',
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-fj-purple",
            cancelButton: "btn btn-light"
          }
        }).then((result) => {
          if (result.isConfirmed) {
            var activate = true;
            performServiceAction(service["name"], clientId, recruiterId, recruiterName, productsIds, AUTH_TOKEN, activate, true);
          }
        });
      }
    }
  }

});





